import type { RoleOption } from '@lighthouse/shared'
import { find } from 'rambda'

export const getGroup = function (activeId: string, roles: RoleOption[]): string {
    return find(item => item.id === activeId, roles)?.name ?? ''
}
